import moment from 'moment';
import { Media, useMedia } from './useMedia';

export interface Tag {
    id: number;
    documentId: string;
    name: string;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
    locale: string;
    slug: string;
    wordpressId: number | null;
    color: string | null;
}

export interface MainTag {
    id: number;
    documentId: string;
    name: string;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
    locale: string;
    slug: string;
    wordpressId: number | null;
    color: string | null;
}

export interface News {
    id: number;
    documentId: string;
    title: string;
    description: string;
    url: string;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
    locale: string;
    slug: string;
    imgUrl: string;
    wordpressId: number;
    publishDate: string;
    content: string;
    image: Media | null;
    tags: Tag[];
    mainTag: MainTag;
}

type imageSize = 'thumbnail' | 'small' | 'medium' | 'large' | 'original';

export function useNews(news: News) {
    function getImage(size: imageSize = 'medium') {
        return news.image ? useMedia(news.image)[size] : news.imgUrl;
    }

    function getTags() {
        return (news.tags ?? []).filter((tag: Tag) => tag.id !== news.mainTag?.id);
    }

    function getMainTag() {
        return news.mainTag ?? news.tags[0] ?? null;
    }
    function getPublishDate() {
        if (!news.publishDate) {
            return '';
        }

        const momentDate = moment(news.publishDate);
        if (moment(new Date()).diff(momentDate, 'days') <= 3) {
            return momentDate.fromNow();
        }

        return momentDate.format('DD MMMM, YYYY');
    }

    return {
        ...news,
        getImage,
        getTags,
        getMainTag,
        getPublishDate,
    };
}
